import { render, staticRenderFns } from "./PsoriasisAffectedAreasPhase.vue?vue&type=template&id=373f5c78&scoped=true&"
import script from "./PsoriasisAffectedAreasPhase.vue?vue&type=script&lang=js&"
export * from "./PsoriasisAffectedAreasPhase.vue?vue&type=script&lang=js&"
import style0 from "./PsoriasisAffectedAreasPhase.vue?vue&type=style&index=0&id=373f5c78&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373f5c78",
  null
  
)

export default component.exports